import { Injectable } from "@angular/core";
import { Router, NavigationStart } from "@angular/router";
import { CurrentPage } from "@app/constant/currentPage.interface";
import { Observable, BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class AlertService {
  private subject = new BehaviorSubject<any>(null);
  private keepAfterNavigationChange = false;
  private unReadNewCall = new BehaviorSubject<any>(null);
  private layoutSetting = new BehaviorSubject<any>({
    showRightContent: false,
    appPageTitle: "",
    showAppHeader: false,
    showAppFooter: false,
  });
  private onlyPartner = new BehaviorSubject<string>("");
  private isMobileDevice = new BehaviorSubject<boolean>(false);
  private isFromThankyou = new BehaviorSubject<boolean>(false);
  private brokerageHouses = new BehaviorSubject<any>([]);
  private currentPage = new BehaviorSubject<CurrentPage>({ route: '', displayName: '', isHelp: false, showBackBtn: true })
  private commonLayoutSetting = new BehaviorSubject<any>({
    showHeader: true,
    showFooter: true
  })
  private globalVideos = new BehaviorSubject<any>({})
  private allMFImages = new BehaviorSubject<any>([])
  private verticals = new BehaviorSubject<any>(null);
  private isAppUpdate = new BehaviorSubject<any>(null);
  private newNotification = new BehaviorSubject<boolean>(false)

  constructor(private router: Router) {
    // clear alert message on route change
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterNavigationChange) {
          // only keep for a single location change
          this.keepAfterNavigationChange = false;
        } else {
          // clear alert
          this.subject.next(null);
        }
      }
    });
  }

  showUnread(data: any, category: any, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.unReadNewCall.next({
      error: false,
      message: { count: data, category: category },
    });
  }

  success(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ error: false, message: { title: message } });
  }

  error(message: any, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ error: true, message });
  }


  getUnReadCalls(): Observable<any> {
    return this.unReadNewCall.asObservable();
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
  setLayout(
    showRightContent: boolean,
    appPageTitle: any,
    showAppHeader: boolean,
    showAppFooter: boolean,
    onlyPage: boolean = false
  ) {
    this.layoutSetting.next({
      showRightContent: showRightContent,
      appPageTitle: appPageTitle,
      showAppHeader: showAppHeader,
      showAppFooter: showAppFooter,
      onlyPage: onlyPage
    });
  }
  getLayout(): Observable<any> {
    return this.layoutSetting.asObservable();
  }
  setOnlyPartner(partner: string) {
    this.onlyPartner.next(partner);
  }
  getOnlyPartner() {
    return this.onlyPartner.asObservable();
  }
  setIsMobileDevice(isMobile: boolean) {
    if (isMobile != this.isMobileDevice.value) {
      this.isMobileDevice.next(isMobile);
    }
  }

  getIsMobileDevice(): Observable<boolean> {
    return this.isMobileDevice.asObservable();
  }
  setisFromThankyou(isFrom: boolean) {
    this.isFromThankyou.next(isFrom);
  }
  getisFromThankyou() {
    return this.isFromThankyou.value;
  }
  setBrokerageHouses(data: any) {
    this.brokerageHouses.next(data);
  }
  getBrokerageHouses(): Observable<any[]> {
    return this.brokerageHouses.asObservable();
  }

  getObjectToQueryString(object: any) {
    return Object.keys(object)
      .map((key) => key + '=' + object[key])
      .join('&');
  }
  addWhatsAppWidget() {
    let script = document.createElement('script');
    script.type = "text/javascript"
    script.setAttribute('id', 'aisensy-wa-widget');
    script.setAttribute('widget-id', '3PYvrG');
    script.setAttribute('src', "https://d3mkw6s8thqya7.cloudfront.net/integration-plugin.js");
    document.head.appendChild(script);
  }
  removeWhatsAppWidget() {
    document.getElementById('aisensy-wa-widget')?.remove();
    document.getElementById('df-style')?.remove();
    document.getElementById('df-script')?.remove();
    document.getElementById('df-btn-cont')?.remove();
  }

  setCurrentPage(data: CurrentPage) {
    if (data.displayName && data.displayName.length > 15) {
      data.displayName = data.displayName.slice(0, 15) + '...'
    } else {
      data.displayName = data.displayName
    }
    this.currentPage.next(data);
  }

  setCurrentPageName(pageName: string) {
    let currentData = this.currentPage.value
    if (pageName.length > 15) {
      currentData.displayName = pageName.slice(0, 15) + '...'
    } else {
      currentData.displayName = pageName
    }
    this.currentPage.next(currentData);
  }

  setCurrentPageHelp(showHelp: boolean = false) {
    let currentData = this.currentPage.value
    currentData.isHelp = showHelp
    this.currentPage.next(currentData);
  }

  setCurrentPageBackBtn(showBackBtn: boolean = true) {
    let currentData = this.currentPage.value
    currentData.showBackBtn = showBackBtn
    this.currentPage.next(currentData);
  }

  getCurrentPage(): Observable<CurrentPage> {
    return this.currentPage.asObservable();
  }
  setCommonLayout(showHeader: boolean = true, showFooter: boolean = true) {
    this.commonLayoutSetting.next({ showHeader, showFooter })
  }
  getCommonLayout(): Observable<{ showHeader, showFooter }> {
    return this.commonLayoutSetting.asObservable()
  }
  setGlobalVideo(data) {
    this.globalVideos.next(data)
  }
  getGlobalVedio() {
    return this.globalVideos.asObservable()
  }

  setMutualFundImages(data) {
    this.allMFImages.next(data)
  }
  getMutualFundImagesList(): Observable<any[]> {
    return this.allMFImages.asObservable()
  }

  setVerticals(data) {
    this.verticals.next(data)
  }
  getVerticals() {
    return this.verticals.asObservable()
  }

  setAppUpdate(version) {
    this.isAppUpdate.next(version)
  }
  appUpdateAvailable() {
    return this.isAppUpdate.asObservable()
  }

  setNotification(){
    this.newNotification.next(true)
  }

  isNewNotification(): Observable<any>{
    return this.newNotification.asObservable()
  }
  goToAdvisorReturnUrl(){
    let _advisor = window.sessionStorage.getItem('sai');
    let _return = window.sessionStorage.getItem('saireturnUrl');
    let _category = window.sessionStorage.getItem('saicategory');
    if (_advisor) {
      let _extra = {};
      if (_category) {
        _extra = { queryParams: { category: _category } }
      }
      this.router.navigate([_return], _extra);
    }
  }
}
